import React from 'react';

const UcFormsApplicationsImage: React.FC = () => {
  return (
    <svg
      width="58px"
      height="57px"
      viewBox="0 0 58 57"
      version="1.1"
      data-testid="svg-image"
    >
      <defs>
        <polygon
          id="path-1"
          points="0 78.944 77.961 78.944 77.961 0 0 0"
        ></polygon>
        <path
          d="M63.692,28.678 L61.001,26.093 L62.285,24.764 L64.976,27.349 L63.692,28.678 Z M55.36,66.432 L12,66.432 L12,14 L55.36,14 L55.36,29.054 L45.486,39.274 L29.675,39.274 C29.123,39.274 28.675,39.722 28.675,40.274 C28.675,40.826 29.123,41.274 29.675,41.274 L43.553,41.274 L37.85,47.178 C37.724,47.307 37.636,47.468 37.595,47.644 L36.514,52.244 L29.675,52.244 C29.123,52.244 28.675,52.692 28.675,53.244 C28.675,53.796 29.123,54.244 29.675,54.244 L37.308,54.244 C37.311,54.244 37.314,54.242 37.317,54.242 C37.397,54.241 37.478,54.232 37.558,54.211 L42.955,52.811 C43.133,52.765 43.295,52.671 43.422,52.538 L55.36,40.181 L55.36,66.432 Z M42.18,50.946 L38.66,51.86 L39.479,48.369 L46.584,41.016 C46.617,40.986 46.646,40.954 46.675,40.92 L57.067,30.165 C57.067,30.165 57.067,30.165 57.068,30.164 L59.612,27.531 L62.303,30.116 L42.18,50.946 Z M67.392,27.304 C67.387,27.038 67.277,26.785 67.085,26.601 L62.951,22.631 C62.554,22.25 61.921,22.261 61.54,22.657 L57.36,26.984 L57.36,13 C57.36,12.448 56.913,12 56.36,12 L11,12 C10.447,12 10,12.448 10,13 L10,67.432 C10,67.984 10.447,68.432 11,68.432 L56.36,68.432 C56.913,68.432 57.36,67.984 57.36,67.432 L57.36,38.111 L67.111,28.017 C67.296,27.826 67.397,27.57 67.392,27.304 Z M20.8736,28.8779 L24.0196,28.8779 L24.0196,25.7319 L20.8736,25.7319 L20.8736,28.8779 Z M25.0196,23.7319 L19.8736,23.7319 C19.3206,23.7319 18.8736,24.1799 18.8736,24.7319 L18.8736,29.8779 C18.8736,30.4309 19.3206,30.8779 19.8736,30.8779 L25.0196,30.8779 C25.5716,30.8779 26.0196,30.4309 26.0196,29.8779 L26.0196,24.7319 C26.0196,24.1799 25.5716,23.7319 25.0196,23.7319 Z M20.8736,41.8489 L24.0196,41.8489 L24.0196,38.7029 L20.8736,38.7029 L20.8736,41.8489 Z M25.0196,36.7029 L19.8736,36.7029 C19.3206,36.7029 18.8736,37.1499 18.8736,37.7029 L18.8736,42.8489 C18.8736,43.4009 19.3206,43.8489 19.8736,43.8489 L25.0196,43.8489 C25.5716,43.8489 26.0196,43.4009 26.0196,42.8489 L26.0196,37.7029 C26.0196,37.1499 25.5716,36.7029 25.0196,36.7029 Z M20.8736,54.8169 L24.0196,54.8169 L24.0196,51.6709 L20.8736,51.6709 L20.8736,54.8169 Z M25.0196,49.6709 C25.5716,49.6709 26.0196,50.1189 26.0196,50.6709 L26.0196,55.8169 C26.0196,56.3689 25.5716,56.8169 25.0196,56.8169 L19.8736,56.8169 C19.3206,56.8169 18.8736,56.3689 18.8736,55.8169 L18.8736,50.6709 C18.8736,50.1189 19.3206,49.6709 19.8736,49.6709 L25.0196,49.6709 Z M29.6754,28.3045 C29.1224,28.3045 28.6754,27.8565 28.6754,27.3045 C28.6754,26.7525 29.1224,26.3045 29.6754,26.3045 L45.9274,26.3045 C46.4804,26.3045 46.9274,26.7525 46.9274,27.3045 C46.9274,27.8565 46.4804,28.3045 45.9274,28.3045 L29.6754,28.3045 Z"
          id="path-3"
        ></path>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="UCS---Forms-&amp;-Applications"
          transform="translate(-396.000000, -89.000000)"
        >
          <g transform="translate(386.000000, 77.000000)">
            <mask id="mask-2" fill="white">
              <use href="#path-1"></use>
            </mask>
            <g id="mask"></g>
            <path
              d="M42.18,50.946 L38.66,51.86 L39.479,48.369 L46.584,41.016 C46.617,40.986 46.646,40.954 46.675,40.92 L57.067,30.165 C57.067,30.165 57.067,30.165 57.068,30.164 L59.612,27.531 L62.303,30.116 L42.18,50.946 Z"
              id="Path"
              fill="#F9BE00"
              mask="url(#mask-2)"
            ></path>
            <mask id="mask-4" fill="white">
              <use href="#path-3"></use>
            </mask>
            <use id="icon" fill="#333E48" href="#path-3"></use>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default UcFormsApplicationsImage;
